module.exports = __webpack_public_path__ + "img/Ic_Play1.4b846516.svg";